import React from "react"
import MenuList from "../../../../../ui/molecules/Menu/MenuList"
import { expandTreeOptions } from "../../../converters/filters"
import { CheckboxFilterOption, FilterCategory } from "../types"

interface Props {
  categories: FilterCategory[]
  onCategoryClick: (category: FilterCategory) => void
}

const getSubtitle = (category: FilterCategory) => {
  if (category.type === "checkbox") {
    const current = expandTreeOptions(
      category.options as CheckboxFilterOption[]
    ).filter((x) => x.selected)
    return current.map((x) => x.label).join(", ")
  }

  return undefined
}

const FilterCategoriesList = ({ categories, onCategoryClick }: Props) => {
  return (
    <MenuList
      items={categories.map((category) => ({
        content: category.name,
        subtitle: getSubtitle(category),
        onItemClick: () => onCategoryClick(category),
      }))}
      bordersBottom
      center
      px={1}
    />
  )
}

export default FilterCategoriesList
